import ClockoutController from '../../../core/clockout.controller';

// const consumer = {
//     name: 'Juan Jurado-Blanco',
//     createdAt: '2025-01-01',
//     totalAdvanced: 1000,
//     averageAdvanced: 100,
//     totalAdvances: 10,
//     averageAdvance: 3,
//     fees: 40,
//     averageFees: 10,
//     active: true,
//     email: 'juan@jurado-blanco.com',
//     phone: '123-456-7890',
//     currentPayPeriod: {
//         startDate: '2025-06-01',
//         endDate: '2025-06-15',
//     },
// };

class UserController extends ClockoutController {
    async initialize() {
        // Check if user has valid data (not just an empty object)
        if (!this.user || !this.user.access || this.user.access.length === 0) {
            this.navigateLogin();
            return;
        }

        const userId = this.props.searchParams.get('userId');
        const consumer = await this.data.fetchConsumerUser(userId);
        console.log('this is the consumer: ', consumer);
        this.setState({ loading: false, user: this.data.user, consumer });
    }

    async restrictUserAccess() {
        // TODO: create functionality to restrict consumer access to Clockout
    }
}

export default UserController;
